export default [
  {
    id: 592,
    name: '',
    address: '624046, Свердловская обл, Белоярский р-н, Совхозный п, Первомайская ул, строение 4',
    phone: '+7 (800) 555-55-55',
    operatingMode: '08.00-23.00',
    geolocation: [56.55649948120117, 61.428733825683594],
    city: 8,
  },
  {
    id: 593,
    name: '',
    address: '623104, Свердловская обл, Первоуральск г, Розы Люксембург ул, 9',
    phone: '+7 (800) 555-55-55',
    operatingMode: '09.00-23.00',
    geolocation: [56.89274597167969, 59.965843200683594],
    city: 52,
  },
  {
    id: 608,
    name: '',
    address: '622004, Свердловская обл, Нижний Тагил г, Ленинградский пр-кт, 12',
    phone: '+7 (800) 555-55-55',
    operatingMode: '09.00-23.00',
    geolocation: [57.90991973876953, 60.08781051635742],
    city: 46,
  },
  {
    id: 609,
    name: '',
    address: '624130, Свердловская обл, Новоуральск г, Савчука ул, 6',
    phone: '+7 (800) 555-55-55',
    operatingMode: '09.00-23.00',
    geolocation: [57.221126556396484, 60.0974235534668],
    city: 50,
  },
  {
    id: 610,
    name: '',
    address: '623530, Свердловская обл, Богдановичский р-н, Богданович г, Первомайская ул, 39',
    phone: '+7 (800) 555-55-55',
    operatingMode: '09.00-23.00',
    geolocation: [56.776241302490234, 62.0441780090332],
    city: 11,
  },
  {
    id: 611,
    name: '',
    address: '624070, Свердловская обл, Среднеуральск г, Набережная ул, Дом 2А',
    phone: '+7 (800) 555-55-55',
    operatingMode: '09.00-23.00',
    geolocation: [56.98695755004883, 60.45705032348633],
    city: 63,
  },
  {
    id: 612,
    name: '',
    address: '623100, Свердловская обл, Первоуральск г, 50 лет СССР ул, 16 А',
    phone: '+7 (800) 555-55-55',
    operatingMode: '08.00-23.00',
    geolocation: [56.888912200927734, 59.881526947021484],
    city: 52,
  },
  {
    id: 613,
    name: '',
    address: '623360, Свердловская обл, Артинский р-н, Манчаж с, Советская ул, 85А',
    phone: '+7 (800) 555-55-55',
    operatingMode: '09.00-23.00',
    geolocation: [56.4771728515625, 58.139068603515625],
    city: 4,
  },
  {
    id: 585,
    name: '',
    address: '620135, Свердловская обл, Екатеринбург г, Красных командиров ул, 72',
    phone: '+7 (800) 555-55-55',
    operatingMode: '09.00-23.00',
    geolocation: [56.89669418334961, 60.6284065246582],
    city: 26,
  },
];
